import { LanguageLocale } from '../../language';
import { IWorkplaceDetails } from '../interface';

export class WorkplaceDetailsConstant {
  get(): IWorkplaceDetails[] {
    return [
      {
        id: 1,
        i18n: [
          // {
          //   name: 'There is a Shuttle Bus',
          //   nameKana: 'There is a Shuttle Bus',
          //   locale: LanguageLocale.USen,
          //   workplaceDetailsId: 1,
          // },
          {
            name: '無料シャトルバスあり',
            nameKana: 'むりょうシャトルバスあり',
            locale: LanguageLocale.JAjp,
            workplaceDetailsId: 1,
          },
        ],
      },
      {
        id: 2,
        i18n: [
          // {
          //   name: 'There is a Parking Lot',
          //   nameKana: 'There is a Parking Lot',
          //   locale: LanguageLocale.USen,
          //   workplaceDetailsId: 1,
          // },
          {
            name: '駐車場あり',
            nameKana: 'ちゅうしゃじょうあり',
            locale: LanguageLocale.JAjp,
            workplaceDetailsId: 1,
          },
        ],
      },
      {
        id: 3,
        i18n: [
          // {
          //   name: 'Foreigners are working',
          //   nameKana: 'Foreigners are working',
          //   locale: LanguageLocale.USen,
          //   workplaceDetailsId: 1,
          // },
          {
            name: '外国人活躍中',
            nameKana: 'がいこくじんかつろちゅう',
            locale: LanguageLocale.JAjp,
            workplaceDetailsId: 1,
          },
        ],
      },
    ];
  }
}
